import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function Onboarding() {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("+549 ");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/orgs/me");
        if (data) navigate("/dashboard", { replace: true });
      } catch {}
    })();
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return toast.error("Nombre requerido");
    setLoading(true);
    try {
      await api.post("/orgs", { name, phone });
      toast.success("Club creado");
      navigate("/dashboard", { replace: true });
    } catch (e) {
      toast.error(e.response?.data?.detail || "Error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 sm:px-6 bg-[#0A0A0A]">
      <div className="max-w-md w-full">
        <div className="font-heading text-3xl sm:text-4xl text-emerald-400 tracking-widest mb-3">MESSIRVE</div>
        <h1 className="font-heading text-3xl sm:text-4xl mb-2">CREÁ TU CLUB</h1>
        <p className="text-zinc-400 text-sm mb-8">Empezás tu prueba de 10 días ahora.</p>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <Label htmlFor="name" className="uppercase tracking-widest text-xs text-zinc-400">Nombre del club</Label>
            <Input id="name" value={name} onChange={(e) => setName(e.target.value)} className="bg-[#0A0A0A] border-[#262626] mt-2 h-12" placeholder="Ej. Club Deportivo Palermo" data-testid="onboarding-name-input" />
          </div>
          <div>
            <Label htmlFor="phone" className="uppercase tracking-widest text-xs text-zinc-400">Teléfono / WhatsApp</Label>
            <Input id="phone" value={phone} onChange={(e) => setPhone(e.target.value)} className="bg-[#0A0A0A] border-[#262626] mt-2 h-12" placeholder="+549 11 2345 6789" data-testid="onboarding-phone-input" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-emerald-500 hover:bg-emerald-600 text-black uppercase tracking-widest font-bold h-12" data-testid="onboarding-submit-btn">
            {loading ? "Creando..." : "Crear y continuar"}
          </Button>
        </form>
      </div>
    </div>
  );
}
